import { FormItemTypes } from '@bimser/core';
import Chart from '../Chart';

export default class BarChart extends Chart {
	constructor() {
		super();
		this.controlType = FormItemTypes.EControlTypes.BarChart;
	}
}
